import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Nature',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "3", y1: "29", x2: "29", y2: "29" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10", x1: "16", y1: "29", x2: "16", y2: "24" }
      }), h("path", {
        attrs: { d: "M25.54 23.5L21.45 19h2.87c.26 0 .4-.31.22-.5L20.5 14h2.83c.26 0 .4-.31.22-.5l-4-4.5h1.79c.26 0 .39-.3.23-.5l-5.35-6.24a.304.304 0 0 0-.46 0L10.42 8.5c-.16.2-.02.5.23.5h1.79l-4 4.5c-.17.19-.03.5.23.5h2.83l-4.05 4.5c-.17.19-.04.5.22.5h2.87l-4.09 4.5c-.17.19-.03.5.23.5h18.64c.26 0 .4-.31.22-.5z" }
      })]
    );
  }
};